import ApiService from "@/common/api/api.service";

let endpoint = "Projeto";

const RH = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    adicionar(form){
        return ApiService.post(`${endpoint}/recurso-humano`, form);
    },

    salvar(form){
        return ApiService.put(`${endpoint}/recurso-humano`, form);
    },

    listar(projetoId, nomeIdProjeto="ProjetoId"){
        return ApiService.get(`${endpoint}/recurso-humano?${nomeIdProjeto}=${projetoId}`);
    },

    deletar(form){
        return ApiService.delete(`${endpoint}/recurso-humano`, form);
    },

    retornaAlocacao(id, nomeIdProjeto="ProjetoId"){
        return ApiService.get(`${endpoint}/alocacao-recurso-humano?${nomeIdProjeto}=${id}`);
    },

    salvarAlocacao(form){
        return ApiService.put(`${endpoint}/alocacao-recurso-humano`, form);
    }
}

export default RH;
